// extracted by mini-css-extract-plugin
export default {"how":"How_how__k1e4c","banner":"How_banner__1wtta"};